var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-window-item',{staticClass:"py-12 ma-auto px-3"},[_c('v-container',{attrs:{"fluid":""}},[_c('InputComponent',{staticClass:"mb-12"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }